module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/sunlight.1e19498.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/sunlight.jpg
// module id = 7maq
// module chunks = 0